/**
 * Created by andrey on 29.05.17.
 */

const LevelView = cc.Node.extend({
    ctor: function (level, parent) {
        this._super();

        this.level = level;

        if (parent !== undefined) {
            this.calculatePosition(parent);
        }

        this.levelBg = this.addLevelBg();
        this.addLevelId();

        if (this.level.type === Level.TYPE_CURRENT) {
            this.addTouchListener();
            cleverapps.UI.applyHover(this.levelBg || this);
        } else if (this.level.type === Level.TYPE_NOTPASSED) {
            cleverapps.tooltipManager.create(this, {
                text: Messages.get("LevelNotPassedTooltip"),
                location: cleverapps.UI.Tooltip.LOCATION_BELOW
            });
        }

        if (this.level.getReward && this.level.getReward() && this.level.type !== Level.TYPE_PASSED) {
            this.createReward(this.level.getReward());
        }

        if (parent === undefined) {
            this.customize();
        }
    },

    createReward: function (reward) {
        const styles = cleverapps.styles.LevelView;

        const bg = new cc.Scale9Sprite(bundles.level.frames.prize_bg_png);
        bg.setContentSize2(styles.prize);

        const arrow = new cc.Sprite(bundles.level.frames.prize_arrow_png);
        bg.addChild(arrow);
        arrow.setAlignment(styles.prize.arrow);

        const type = Object.keys(reward)[0];
        const text = new TextWithIcon(`${TextWithIcon.ICONS_BY_NAME[type]} x${reward[type].factor}`, {
            font: cleverapps.styles.FONTS.LEVEL_REWARD_TEXT
        });
        bg.addChild(text);
        text.setAlignment(bg.width / 2 + styles.prize.offset.x, bg.height / 2 + styles.prize.offset.y);

        this.addChild(bg);
        bg.setAlignment(styles.prize);

        bg.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.MoveBy(1, 0, styles.prize.animation.dy).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(1, 0, -styles.prize.animation.dy).easing(cc.easeInOut(1.7))
            )
        ));
    },

    calculatePosition: function () {
        const styles = cleverapps.styles.LevelsView;
        let position = (this.level.stage % 2) && styles.levels_2 || styles.levels_1;
        position = position[this.level.progress];
        if (position) {
            this.setPosition(position);
        }
    },

    customize: function () {

    },

    getAnimationName: function () {
        let animation = ["past", "current", "future"];
        if (this.level.isHard()) {
            animation = ["hard_past", "hard_current", "hard_future"];
        } else if (this.level.isBonus()) {
            animation = ["bonus_past", "bonus_current", "bonus_future"];
        }
        return animation[this.level.type];
    },

    getImage: function () {
        const bgImagesNames = ["level_past_png", "level_current_png", "level_future_png"];
        let bgImageName = bgImagesNames[this.level.type];
        if (this.level.isHard()) {
            bgImageName = "level_hard_png";
        } else if (this.level.isBonus()) {
            bgImageName = "level_bonus_png";
        } else if (this.level.isTricky()) {
            bgImageName = "level_tricky_png";
        }
        const bg = new cc.Sprite(bundles.level.frames[bgImageName]);
        bg.setAnchorPoint(0.5, 0.5);

        const stars = this.getStars();
        if (stars !== undefined && this.level.type === Level.TYPE_PASSED) {
            const starsImageName = `star_${this.getStars()}_png`;
            const starsImage = new cc.Sprite(bundles.level.frames[starsImageName]);
            starsImage.setAnchorPoint(0.5, 0.5);
            starsImage.setAlignment(cleverapps.styles.LevelView.stars);
            bg.addChild(starsImage);
        }

        return bg;
    },
    
    getStars: function () {
        if (cleverapps.config.type !== "match3" || cleverapps.config.rpg) {
            return undefined;
        }

        if (this.level.type === Level.TYPE_CURRENT) {
            return;
        }

        if (this.level.type === Level.TYPE_PASSED) {
            return this.level.stars !== undefined ? this.level.stars : 0;
        }
    },

    addLevelBg: function () {
        const styles = cleverapps.styles.LevelView;
        const levelBg = new cc.Node();
        levelBg.setAnchorPoint(0.5, 0.5);
        levelBg.setContentSize(styles.clickSize);
        this.setContentSize(levelBg.getContentSize());
        let bgImage;
        if (bundles.level.jsons.level_json) {
            const animationName = this.getAnimationName();
            bgImage = new cleverapps.Spine(bundles.level.jsons.level_json);
            bgImage.setAnimation(0, animationName, true);
        } else {
            bgImage = this.getImage();
            if (this.level.type === Level.TYPE_CURRENT) {
                levelBg.runAction(new cc.RepeatForever(
                    new cc.Sequence(
                        new cc.ScaleTo(0.83, 1.19),
                        new cc.ScaleTo(0.5, 1)
                    )
                ));
            }
        }
        bgImage.setPosition(levelBg.width / 2, levelBg.height / 2 + styles.dy);
        levelBg.addChild(bgImage);
        levelBg.setAlignment(this.width / 2, this.height / 2);
        this.setAnchorPoint(0.5, 0.5);
        this.addChild(levelBg);
        return levelBg;
    },

    addLevelId: function () {
        if (!((this.level.isHard() || this.level.isBonus() || this.level.isTricky()) && cleverapps.styles.LevelView.hidableLevelNo)) {
            LevelView.generateLevelId(this.levelBg, this.level.type, this.level.getHumanReadableNumber());
        }
    },

    addTouchListener: function () {
        cleverapps.UI.onClick(this, this.onPressed.bind(this));
    },

    onPressed: function () {
        cleverapps.effects.fire("ui.button.click");
        this.level.onPressed();
    }
});

LevelView.generateLevelId = function (parent, type, levelNumber) {
    const styles = cleverapps.styles.LevelView.LevelId;

    if (!cleverapps.config.editorMode && styles.showTypes.indexOf(type) === -1) {
        return;
    }

    let font = cleverapps.styles.FONTS.LEVEL_TITLE_TEXT;
    if (type === Level.TYPE_NOTPASSED) {
        font = cleverapps.styles.FONTS.LEVEL_NOT_PASSED_TITLE_TEXT;
    }
    if (type === Level.TYPE_CURRENT && cleverapps.styles.FONTS.LEVEL_CURRENT_TITLE_TEXT) {
        font = cleverapps.styles.FONTS.LEVEL_CURRENT_TITLE_TEXT;
    }
    if (type === Level.TYPE_PASSED && cleverapps.styles.FONTS.LEVEL_PASSED_TITLE_TEXT) {
        font = cleverapps.styles.FONTS.LEVEL_CURRENT_TITLE_TEXT;
    }
    const levelId = cleverapps.UI.generateImageText(levelNumber, font);

    let scale;
    let anchorY;
    if (levelNumber >= 1000) {
        scale = styles.alternativeSizes[0];
        anchorY = styles.alternativeAnchorsY[0];
    } else if (levelNumber >= 100) {
        scale = styles.alternativeSizes[1];
        anchorY = styles.alternativeAnchorsY[1];
    } else {
        scale = styles.alternativeSizes[2];
        anchorY = styles.alternativeAnchorsY[2];
    }
    if (scale) {
        levelId.setScale(levelId.scale * scale);
    }

    if (styles.scale && levelNumber % 2) {
        levelId.setScale(levelId.scale * 0.9);
    }
    levelId.setAnchorPoint(0.5, anchorY);
    parent.addChild(levelId);
    parent.levelId = levelId;

    const position = styles;
    levelId.setAlignment(position.x, position.y);
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LEVEL_TITLE_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    LEVEL_NOT_PASSED_TITLE_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    LEVEL_REWARD_TEXT: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.LevelView = {
    dy: -10,

    LevelId: {
        alternativeSizes: [0.6, 0.7, 0.8],
        alternativeAnchorsY: [0.1, 0.2, 0.2],
        x: { dx: 0 },
        y: { dy: 0 },
        showTypes: [Level.TYPE_PASSED, Level.TYPE_CURRENT, Level.TYPE_NOTPASSED]
    },

    clickSize: {
        width: 90,
        height: 75
    },
    
    stars: {
        x: { align: "center" },
        y: { align: "center", dy: 50 }
    },

    prize: {
        width: 170,
        height: 130,

        x: { align: "center" },
        y: { align: "top", dy: 140 },

        arrow: {
            x: { align: "center" },
            y: { align: "bottom", dy: -27 }
        },

        animation: {
            dy: 20
        },

        offset: {
            x: -7,
            y: 7
        }
    }
};